export const PRAYER_REQUEST_TYPE_LABELS = {
    all: "அனைத்தும்",
    health_and_healing: "உடல்நலம் மற்றும் குணமடைதல்",
    family: "குடும்பம்",
    marriage: "திருமணம்",
    children: "குழந்தைகள்",
    work_and_career: "வேலை மற்றும் தொழில்",
    education: "கல்வி",
    financial_needs: "நிதி தேவைகள்",
    spiritual_growth: "ஆன்மீக வளர்ச்சி",
    guidance_and_wisdom: "வழிகாட்டுதல் மற்றும் ஞானம்",
    peace_of_mind: "மன அமைதி",
    thanksgiving: "நன்றி ஜெபம்",
    church_ministry: "திருச்சபை மற்றும் ஊழியம்",
    emergency_prayer: "அவசர ஜெபம்",
    travel_and_protection: "பயணம் மற்றும் பாதுகாப்பு",
    salvation: "இரட்சிப்பு",
    others: "மற்றவை",
};

// Convert API options → Tamil dropdown
export const mapPrayerRequestTypeOptions = (options = []) => {
    return options
        // ❌ remove "All" option
        .filter(
            (item) =>
                item.name?.toLowerCase() !== "all" &&
                item.label?.toLowerCase() !== "all"
        )
        .map((item) => {
            const key = (item.name || item.label || "")
                .toLowerCase()
                .replace(/&/g, "and")
                .replace(/\s+/g, "_");

            return {
                value: item.id || item.value,
                label: PRAYER_REQUEST_TYPE_LABELS[key] || item.name || item.label,
            };
        });
};